import React from 'react';

const AccountSection = () => {
    return (
        <section id="accountSection" class="dashboard-section">
            <div class="bg-white rounded-xl shadow-sm p-6">
                <h2 class="text-xl font-semibold mb-6 text-gray-800">My Account</h2>
                <form id="accountForm">
                    <div class="mb-6">
                        <label class="block text-gray-700 font-medium mb-2">Profile Picture</label>
                        <div class="flex items-center space-x-4">
                            <div class="h-16 w-16 rounded-full bg-blue-100 flex items-center justify-center">
                                <i class="fas fa-user text-blue-600 text-2xl"></i>
                            </div>
                            <div>
                                <button type="button" class="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition">
                                    Change Photo
                                </button>
                                <button type="button" class="text-red-600 hover:text-red-800 ml-2">
                                    Remove
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="grid md:grid-cols-2 gap-6 mb-6">
                        <div>
                            <label class="block text-gray-700 font-medium mb-2">First Name</label>
                            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value="Admin" />
                        </div>
                        <div>
                            <label class="block text-gray-700 font-medium mb-2">Last Name</label>
                            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value="User" />
                        </div>
                    </div>
                    <div class="mb-6">
                        <label class="block text-gray-700 font-medium mb-2">Email</label>
                        <input type="email" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value="admin@autopart.com" />
                    </div>
                    <div class="mb-6">
                        <label class="block text-gray-700 font-medium mb-2">Current Password</label>
                        <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    </div>
                    <div class="grid md:grid-cols-2 gap-6 mb-6">
                        <div>
                            <label class="block text-gray-700 font-medium mb-2">New Password</label>
                            <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                        <div>
                            <label class="block text-gray-700 font-medium mb-2">Confirm Password</label>
                            <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>
                    </div>
                    <div class="flex justify-end">
                        <button type="submit" class="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition">
                            Save Changes
                        </button>
                    </div>
                </form>
            </div>
            
            {/* Add user modal, need to move */}
            <div id="addUserModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 modal modal-hidden">
                <div class="bg-white rounded-xl shadow-sm p-6 w-full max-w-md relative">
                    <button id="closeAddUserModalBtn" class="absolute top-4 right-4 text-gray-500 hover:text-gray-700">
                        <i class="fas fa-times"></i>
                    </button>
                    <h2 class="text-xl font-bold mb-6 text-gray-800">Add New User</h2>
                    <form id="addUserForm">
                        <div class="mb-6">
                            <label class="block text-gray-700 font-medium mb-2">Full Name</label>
                            <input type="text" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter full name"/>
                        </div>
                        <div class="mb-6">
                            <label class="block text-gray-700 font-medium mb-2">Email</label>
                            <input type="email" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter email address"/>
                        </div>
                        <div class="mb-6">
                            <label class="block text-gray-700 font-medium mb-2">Role</label>
                            <select class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option>Admin</option>
                                <option>Scanner</option>
                                <option>Viewer</option>
                            </select>
                        </div>
                        <div class="mb-6">
                            <label class="block text-gray-700 font-medium mb-2">Password</label>
                            <input type="password" class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Set password"/>
                        </div>
                        <div class="flex justify-end">
                            <button type="button" id="cancelAddUserBtn" class="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg font-medium hover:bg-gray-300 transition mr-3">
                                Cancel
                            </button>
                            <button type="submit" class="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition">
                                Add User
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default AccountSection;